import { render, staticRenderFns } from "./IconsDialog.vue?vue&type=template&id=585439f6&scoped=true"
import script from "./IconsDialog.vue?vue&type=script&lang=js"
export * from "./IconsDialog.vue?vue&type=script&lang=js"
import style0 from "./IconsDialog.vue?vue&type=style&index=0&id=585439f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585439f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585439f6')) {
      api.createRecord('585439f6', component.options)
    } else {
      api.reload('585439f6', component.options)
    }
    module.hot.accept("./IconsDialog.vue?vue&type=template&id=585439f6&scoped=true", function () {
      api.rerender('585439f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/IconsDialog.vue"
export default component.exports